import generateFilterModule from './generateFilterModule'

export default generateFilterModule('timeline')
